// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CartItem_checkbox__1wryp"};